var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0004 6.64449C14.9504 6.63615 14.8921 6.63615 14.8421 6.64449C13.6921 6.60282 12.7754 5.66115 12.7754 4.49448C12.7754 3.30282 13.7337 2.34448 14.9254 2.34448C16.1171 2.34448 17.0754 3.31115 17.0754 4.49448C17.0671 5.66115 16.1504 6.60282 15.0004 6.64449Z",
    stroke: "#494A4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1422 12.711C15.2839 12.9027 16.5422 12.7027 17.4255 12.111C18.6005 11.3277 18.6005 10.0444 17.4255 9.26104C16.5339 8.66937 15.2589 8.46937 14.1172 8.66937",
    stroke: "#494A4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97344 6.64449C5.02344 6.63615 5.08177 6.63615 5.13177 6.64449C6.28177 6.60282 7.19844 5.66115 7.19844 4.49448C7.19844 3.30282 6.24011 2.34448 5.04844 2.34448C3.85677 2.34448 2.89844 3.31115 2.89844 4.49448C2.90677 5.66115 3.82344 6.60282 4.97344 6.64449Z",
    stroke: "#494A4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83255 12.711C4.69088 12.9027 3.43255 12.7027 2.54922 12.111C1.37422 11.3277 1.37422 10.0444 2.54922 9.26104C3.44089 8.66937 4.71588 8.46937 5.85755 8.66937",
    stroke: "#494A4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 12.8693C9.95039 12.861 9.89206 12.861 9.84206 12.8693C8.69206 12.8277 7.77539 11.886 7.77539 10.7193C7.77539 9.52767 8.73372 8.56934 9.92539 8.56934C11.1171 8.56934 12.0754 9.536 12.0754 10.7193C12.0671 11.886 11.1504 12.836 10.0004 12.8693Z",
    stroke: "#494A4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57461 15.4943C6.39961 16.2776 6.39961 17.561 7.57461 18.3443C8.90794 19.236 11.0913 19.236 12.4246 18.3443C13.5996 17.561 13.5996 16.2776 12.4246 15.4943C11.0996 14.611 8.90794 14.611 7.57461 15.4943Z",
    stroke: "#494A4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.c7118db3ae4cfcd50bc7f21ef7b60d95.svg";
export { ForwardRef as ReactComponent };